module.exports = __webpack_public_path__ + "static/media/mic_off.89860916.svg";